// To do: Fix responsiveness of table and form
import { Heading, Container, VStack, Text } from "@chakra-ui/react";
import Layout from "../../../layout/Layout";
import { Element } from "react-scroll";
import ContentMenu from "../../../components/content-menu";

export default function PlaceDetail() {
  const navItemsv1 = [
    { title: "Places Detail API", nav: "detailsapi" },
    { title: "Try out the API", nav: "playground" },
  ];

  return (
    <Layout
      children={
        <Container maxW={"7xl"} p="12">
          <ContentMenu items={navItemsv1} />
          <VStack spacing="10" alignItems="flex-start">
            <Element name="detailsapi">
              <Heading as="h2">Places Detail</Heading>
              <Text as="p" fontSize={"lg"} mt={5} textDecoration={"underline"}>
                v1/places/detail
              </Text>
              <Text as="p" fontSize="lg" mt={5}>
                Comming soon ...
              </Text>
            </Element>
          </VStack>
        </Container>
      }
    />
  );
}
